<template>
    <div v-if="showComponent" class="subcategories-bottom-button subcategories-filter-reset">
        <h2>{{ __('frontend_js.category.that-is-not-all') }}</h2>
        <p>{{ __('frontend_js.category.see-them-all') }} {{ selectedCategoryName }} ({{ additionalColoredProductsCount }})</p>
        <!-- <button class="" @click="cancelFilters">
                <span>{{ categoryTitle }} ({{ coloredProducts.length }})</span>
            </button> -->
        <button class="text-uppercase shop-button spinnerButton" @click="redirect">
            {{ __('frontend_js.category.additional') }} {{ selectedCategoryName }} ({{ additionalColoredProductsCount }})
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            isFetching: false,
            data: null,
        };
    },
    computed: {
        ...mapGetters({
            filters: 'product-filters/filters',
            coloredProducts: 'product-list/coloredProducts',
            lastPageParsed: 'product-list/lastPageParsed',
        }),
        showComponent() {
            return (
                !this.isFetching &&
                this.lastPageParsed == this.coloredProducts.current_page &&
                this.data &&
                this.filters.categories.length > 1
            );
        },
        selectedCategoryId() {
            return this.filters.categories.length == 0 ? null : this.filters.categories[this.filters.categories.length - 1];
        },
        selectedCategoryName() {
            return this.data?.category_title;
        },
        selectedCategorySlug() {
            return '/' + this.data?.category_slug;
        },
        additionalColoredProductsCount() {
            return this.data?.colored_products_count;
        },
    },

    created() {
        this.fetchData();
    },

    watch: {
        selectedCategoryId() {
            this.fetchData();
        },
    },

    methods: {
        async fetchData() {
            if (this.filters.categories.length < 2) return;

            this.isFetching = true;
            this.$http
                .get(`/category/${this.selectedCategoryId}/colored-products/thats-not-all`)
                .then(res => {
                    this.data = res.data;
                })
                .catch(e => {
                    this.data = null;
                    console.log(e);
                })
                .finally(() => {
                    this.isFetching = false;
                });
        },
        redirect() {
            window.location.href = this.selectedCategorySlug;
        },
    },
};
</script>
